import { render, staticRenderFns } from "./UsuarioConsignatariaForm.vue?vue&type=template&id=645c1181&"
import script from "./UsuarioConsignatariaForm.vue?vue&type=script&lang=js&"
export * from "./UsuarioConsignatariaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports